export default "__VITE_ASSET__14992854__"